
import './Banner.css'; 

function Banner() {
    return (
        <header className="banner">
            <img src="/imagens/Banner3.png" alt="banner principal da página do Organo"/>
        </header>
    )
}

export default Banner;  